import { MBDropdownProps } from '../MBDropdown';
import { ViewTypeEnum } from '../ResultsSettings';

export enum GridSelectorVariant {
  DEFAULT = 'default',
  SLIDER_ONLY = 'slider-only',
  SLIDER_WITH_CARD_INFO = 'slider-width-card-info',
}

export enum CardInfoLevel {
  HIDE = 'hide',
  LESS_INFO = 'less-info',
  MORE_INFO = 'more-info',
}
export interface GridTypeSelectorProps extends MBDropdownProps {
  open: boolean;
  selectedKey: ViewTypeEnum;
  availableGridTypes: ViewTypeEnum[];
  onMenuItemClick: (key: ViewTypeEnum) => void;
  gridSelectorVariant: GridSelectorVariant;
  cardInfoLevel?: CardInfoLevel;
  onCardInfoLevelChange?: (value: CardInfoLevel) => void;
  sliderValue?: number;
  onSliderChange?: (value: number) => void;
  minSliderValue?: number;
  maxSliderValue?: number;
  defaultSliderValue?: number;
  isToggleButtonsDisabled?: boolean;
  isSliderDisabled?: boolean;
  isColumnSlider?: boolean;
  isColumnToggles?: boolean;
  columnsToggleValue?: number;
  onColumnsToggleChange?: (value: number) => void;
  disableGridTypeSelector?: boolean;
  cardSizeLabel?: string;
  cardInfoLabel?: string;
}
